module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/babel-runtime/core-js/object/assign.js
// module id = 552
// module chunks = 0